import React from 'react';
import { Spin } from 'antd';
import withContent from 'modules/CMS/components/withContent';
import CMS from 'modules/CMS/components';

const isNumber = value => !Number.isNaN(parseFloat(value));

class CMSPageRender extends React.PureComponent {
  render () {
    const { pageId } = this.props;

    if (!isNumber(pageId)) {
      return <Spin />;
    }

    const Component = withContent(pageId)(({ title, content }) => (
      <CMS title={title} body={content} />
    ));
    return <Component />;
  }
}

export default CMSPageRender;



// WEBPACK FOOTER //
// ./src/components/CMSPage/CMSPage.js